/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RightStatus {
    ACTIVE = 'Active',
    RELEASED = 'Released',
    EXPIRED = 'Expired',
}
